var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMaText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "e7zmtcbf3a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.166 4.074v2.222c0 .445-.296.741-.74.741-.445 0-.741-.296-.741-.74V4.814H11.24v10.37h1.482c.444 0 .74.297.74.741s-.296.74-.74.74H8.277c-.444 0-.74-.296-.74-.74s.296-.74.74-.74H9.76V4.814H5.314v1.481c0 .445-.296.741-.74.741-.445 0-.741-.296-.741-.74V4.073c0-.444.296-.74.74-.74h11.853c.444 0 .74.296.74.74z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e7zmtcbf3a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M.5 0h20v20H.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaText);
export default __webpack_public_path__ + "static/media/ic-ma-text.260eed579c4b94802b721279a75f105d.svg";
export { ForwardRef as ReactComponent };